import React from "react";

export default (props) => {
    const {size} = props;
    return (
        <i className={`sprite sprite-edit${size === "lg"  ? '-lg': ''}`}></i>
    )
};
